if (!window._breeze) {
    window._breeze = true;
    window.addEventListener('click', (event) => {
      // quickview overlapping checkout
      if (event.target.closest('.shopify-payment-button, button[name="add"]')) {
        const quickView = document.querySelector('.quick-add-modal');
        if (quickView && quickView.hasAttribute('open')) {
          quickView.querySelector('.quick-add-modal__close')?.click();
        }
      }
    }, true);
}